import * as React from 'react';
import { observer } from 'mobx-react';

// types
import { NativeMediaProps } from './types';

// components
import Video from '../../../Video/Video';
import { StyledImage, StyledMedia } from './styledComponents';

// helpers
import { css } from 'components/_UI/designSystem';
import {
    getBackgroundOffset,
    getEnrichment,
    getImageUrl,
    getVideoUrl,
    getVideoUrlPoster,
} from './helpers';

const NativeMedia: React.FC<NativeMediaProps> = ({
    aspectRatio,
    images,
    videos,
    snType,
    playerInterval,
}) => {
    const imageUrl = getImageUrl(images) || getVideoUrlPoster(videos);
    const enrichment = getEnrichment(images);
    const videoUrl = getVideoUrl(videos);
    const percentage = aspectRatio && (aspectRatio[1] / aspectRatio[0]) * 100;
    return (
        <StyledMedia percentage={percentage}>
            <>
                {imageUrl && (
                    <StyledImage
                        key='image'
                        url={imageUrl}
                        enrichment={enrichment}
                        css={css`
                            background-position: ${getBackgroundOffset(enrichment)};
                        `}
                    />
                )}
                {videoUrl && (
                    <Video
                        playerInterval={playerInterval}
                        type={snType}
                        key='postVideo'
                        url={videoUrl}
                        poster={videos[0].poster || imageUrl || null}
                        width='100%'
                        height='100%'
                        play
                        hasOverlay={false}
                        hidePosterAfterPlay
                        showControls={false}
                        autoplay
                    />
                )}
            </>
        </StyledMedia>
    );
};

NativeMedia.displayName = 'NativeMedia';
export default observer(NativeMedia);
